import { render, staticRenderFns } from "./RequestList.vue?vue&type=template&id=68d1f3cc&scoped=true&"
import script from "./RequestList.vue?vue&type=script&lang=js&"
export * from "./RequestList.vue?vue&type=script&lang=js&"
import style0 from "./RequestList.vue?vue&type=style&index=0&id=68d1f3cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d1f3cc",
  null
  
)

export default component.exports